"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.templateCaches = exports.templateFactory = void 0;
const template_js_1 = require("./template.js");
function templateFactory(result) {
    let templateCache = exports.templateCaches.get(result.type);
    if (templateCache === undefined) {
        templateCache = {
            stringsArray: new WeakMap(),
            keyString: new Map()
        };
        exports.templateCaches.set(result.type, templateCache);
    }
    let template = templateCache.stringsArray.get(result.strings);
    if (template !== undefined) {
        return template;
    }
    const key = result.strings.join(template_js_1.marker);
    template = templateCache.keyString.get(key);
    if (template === undefined) {
        template = new template_js_1.Template(result, result.getTemplateElement());
        templateCache.keyString.set(key, template);
    }
    templateCache.stringsArray.set(result.strings, template);
    return template;
}
exports.templateFactory = templateFactory;
exports.templateCaches = new Map();
